module.exports = __webpack_public_path__ + "img/love-paws-homestay-pet-daycare-bg.9cff3f39.jpg";